import { computed, ref, Ref, watch } from "vue";
import { GenericField } from "@/business/shared/commons/validator/validatorsTypes";
import { RequiredRule } from "@/business/shared/commons/validator/rules/RequiredRule";
import { validator } from "@/business/shared/commons/validator/validator";
import { NumericRule } from "@/business/shared/commons/validator/rules/NumericRule";
import { EmailRule } from "@/business/shared/commons/validator/rules/EmailRule";

export function createEditClientValidator() {
  const identificationType: Ref<GenericField> = ref({
    enabled: false,
    errors: [],
    isSuccess: true,
    val: "",
    rules: [new RequiredRule("El tipo de identificación es obligatorio")],
  });
  const identificationNumber: Ref<GenericField> = ref({
    enabled: false,
    errors: [],
    isSuccess: true,
    val: "",
    rules: [new RequiredRule("El número de identificación es obligatorio")],
  });
  const company: Ref<GenericField> = ref({
    enabled: false,
    errors: [],
    isSuccess: true,
    val: "",
    rules: [
      new RequiredRule(
        "El nombre de la empresa es obligatorio"
      ),
    ],
  });
  const contactName: Ref<GenericField> = ref({
    enabled: false,
    errors: [],
    isSuccess: true,
    val: "",
    rules: [
      new RequiredRule(
        "El nombre de la persona de contacto es obligatorio"
      ),
    ],
  });
  const contactEmail: Ref<GenericField> = ref({
    enabled: false,
    errors: [],
    isSuccess: true,
    val: "",
    rules: [
      new RequiredRule(
        "El correo electrónico de contacto es obligatorio"
      ),
      new EmailRule("El correo electrónico debe tener un cormato válido"),
    ],
  });
  const contactPhone: Ref<GenericField> = ref({
    enabled: false,
    errors: [],
    isSuccess: true,
    val: "",
    rules: [
      new RequiredRule(
        "El número de contacto es obligatorio"
      ),
      new NumericRule(
        "El número de contacto debe ser numérico"
      ),
    ],
  });
  const billingEmail: Ref<GenericField> = ref({
    enabled: false,
    errors: [],
    isSuccess: true,
    val: "",
    rules: [
      new RequiredRule(
        "El correo electrónico de facturación es obligatorio"
      ),
      new EmailRule("El correo electrónico debe tener un formato válido"),
    ],
  });

  watch(
    () => identificationType.value.val,
    () => {
      if ((identificationType.value.val?.length ?? 0) > 0) {
        identificationType.value.enabled = true;
      }
    }
  );
  watch(
    () => identificationNumber.value.val,
    () => {
      if ((identificationNumber.value.val?.length ?? 0) > 0) {
        identificationNumber.value.enabled = true;
      }
    }
  );
  watch(
    () => company.value.val,
    () => {
      if ((company.value.val?.length ?? 0) > 0) {
        company.value.enabled = true;
      }
    }
  );
  watch(
    () => contactName.value.val,
    () => {
      if ((contactName.value.val?.length ?? 0) > 0) {
        contactName.value.enabled = true;
      }
    }
  );
  watch(
    () => contactEmail.value.val,
    () => {
      if ((contactEmail.value.val?.length ?? 0) > 0) {
        contactEmail.value.enabled = true;
      }
    }
  );
  watch(
    () => contactPhone.value.val,
    () => {
      if ((contactPhone.value.val?.length ?? 0) > 0) {
        contactPhone.value.enabled = true;
      }
    }
  );
  watch(
    () => billingEmail.value.val,
    () => {
      if ((billingEmail.value.val?.length ?? 0) > 0) {
        billingEmail.value.enabled = true;
      }
    }
  );

  function validate(field: GenericField, otherValue?: string): GenericField {
    return validator().validateField(field, otherValue);
  }

  const successForm = computed(() => {
    identificationType.value = validate(identificationType.value);
    identificationNumber.value = validate(identificationNumber.value);
    company.value = validate(company.value);
    contactName.value = validate(contactName.value);
    contactEmail.value = validate(contactEmail.value);
    contactPhone.value = validate(contactPhone.value);
    billingEmail.value = validate(billingEmail.value);

    return !(
      identificationType.value.isSuccess &&
      identificationNumber.value.isSuccess &&
      company.value.isSuccess &&
      contactName.value.isSuccess &&
      contactEmail.value.isSuccess &&
      contactPhone.value.isSuccess &&
      billingEmail.value.isSuccess
    );
  });

  function reset(): void {
    identificationType.value.val = "";
    identificationNumber.value.val = "";
    company.value.val = "";
    contactName.value.val = "";
    contactEmail.value.val = "";
    contactPhone.value.val = "";
    billingEmail.value.val = "";
    identificationType.value.enabled = false;
    identificationNumber.value.enabled = false;
    company.value.enabled = false;
    contactName.value.enabled = false;
    contactEmail.value.enabled = false;
    contactPhone.value.enabled = false;
    billingEmail.value.enabled = false;
  }

  return {
    identificationType,
    identificationNumber,
    company,
    contactName,
    contactEmail,
    contactPhone,
    billingEmail,
    successForm,
    reset,
  };
}
